import React, { useState } from 'react'
import { getBEMCls } from '@/utils/classname'
import { Expaned } from '@/components/layout/layout'
import Button from '@/components/button/button'
import { showLayer } from '@/utils/layer'

import './stock-update.scss'
import StockUpdateTable from './stock-update-table/stock-update-table'
import StockUpdateForm from './stock-update-form/stock-update-form'
import { DatePicker } from 'antd'

const StockUpdate = () => {
    const getCls = (e?: string, m?: string) => getBEMCls('stock-update', e, m)

    const [refreshStatus, setRefreshStatus] = useState<boolean>(false)

    const [date, setDate] = useState<string[]>([])

    return (
        <>
            <Expaned className={getCls()}>
                <div className={getCls('header')}>
                    <Button
                        types="default"
                        onClick={() => {
                            showLayer(
                                <StockUpdateForm
                                    refresh={() => {
                                        setRefreshStatus(!refreshStatus)
                                    }}
                                />,
                            )
                        }}
                    >
                        添加盘点单
                    </Button>
                    <div
                        className="time-picker"
                        style={{
                            marginLeft: '16px',
                        }}
                    >
                        <DatePicker.RangePicker
                            dateRender={current => (
                                <div
                                    className="ant-picker-cell-inner"
                                    style={{
                                        borderRadius: '50%',
                                    }}
                                >
                                    {current.date()}
                                </div>
                            )}
                            onChange={(monent, dateString) => {
                                setDate(dateString[0] ? dateString : [])
                            }}
                            suffixIcon={<i className="iconfont iconshijianshaixuan" />}
                        />
                    </div>
                </div>
                <Expaned data-row className={getCls('content')}>
                    <StockUpdateTable date={date} refreshStatus={refreshStatus} />
                </Expaned>
            </Expaned>
        </>
    )
}

export default StockUpdate
